import { apolloClientAtom, useApolloHotReload } from "@/admin/graphql/apolloClientAtom.tsx";
import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import { ApolloProvider } from "@apollo/client/react";
import { useAtomValue } from "jotai/react";
import type { ReactNode } from "react";

if (import.meta.env.DEV) {
    // Adds messages only in a dev environment
    loadDevMessages();
    loadErrorMessages();
}

export default function DefaultApolloProvider({ children }: { children: ReactNode }) {
    const client = useAtomValue(apolloClientAtom);
    useApolloHotReload(client);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
